import React from 'react';
import { motion } from 'framer-motion';
import { CakeSliceIcon } from 'lucide-react';
interface CTAButtonProps {
  className?: string;
  text?: string;
  href?: string;
}
export function CTAButton({
  className = '',
  text = 'PAGAR CON TARJETA / REGISTRO WEB',
  href = 'https://app.komvii.com/checkout/46ivSziFhU4jNa3swZrBiWYuyNJjuOs2?p=Mjg4'
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  const handleClick = () => {
    if (isExternal && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Manual Repostería de Guerra',
        content_type: 'product',
        value: 6.36,
        currency: 'USD'
      });
    }
  };
  return <motion.a href={href} onClick={handleClick} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.98
  }} className={`inline-flex items-center justify-center gap-3 bg-amber hover:bg-amber-dark text-white font-bold text-xl md:text-2xl py-5 px-10 md:py-6 md:px-12 rounded-full shadow-warm transition-colors w-full md:w-auto ${className}`} data-id="element-12">
      <CakeSliceIcon className="w-6 h-6" data-id="element-13" />
      <span data-id="element-14">{text}</span>
    </motion.a>;
}